import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import classes from './NavigationItem.scss';

const navigationItem = ( props ) => {
    return (
        <li className={classes.NavigationItem}>
        <NavLink
            to={props.link} 
            exact={props.exact}
            activeClassName={classes.active}>
            <div className={classes.NavigationImageWrapper}>
                <img src={props.image} alt='' className={classes.NavigationImage}/>
            </div>
            <div className={classes.NavigationItemInner} style={{
                transform: props.navigationItemActive ? 'translateX(0)' : 'translateX(-1rem)'
            }}>{props.children}</div>
            </NavLink>
        </li>
    );
}

export default withRouter(navigationItem);


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.js